import { ModelExecutionStage, RunIntentType } from './shared';

export const executionStageToRunIntentType = (
  selectType: ModelExecutionStage,
): RunIntentType => {
  switch (selectType) {
    case ModelExecutionStage.Dev:
    case ModelExecutionStage.Test:
      return 'dev-testing';
    case ModelExecutionStage.UAT:
      return 'uat';
    case ModelExecutionStage.Prod:
      return 'prod';
  }
};

export const idGenerator = (
  size = 11,
  alphabets = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz',
): string =>
  `${alphabets[Math.floor(Math.random() * alphabets.length)]}${
    size - 1 ? idGenerator(size - 1, alphabets) : ''
  }`;
